import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'reactstrap';
import {CustomReload} from "../../../AppSystem/Helpers/CustomReload";
import {CustomModal} from "./CustomModal";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

// IMPORTANT: IF PAGE HAS A BACK BUTTON, MUST BE ADDED CLASS "backButton" TO BUTTON ELEMENT

export function CustomUnsavedModal({ backButtonUrl = null, modalMessage = null }) {
    const { t } = useTranslation();

    const navigate = useNavigate()
    const HISTORY_BACK_ACTION = '__history_back__';

    const [displayUnsavedModal, setDisplayUnsavedModal] = useState(false);
    const [navigateUrl, setNavigateUrl] = useState("");
    const allowHistoryNavigationRef = useRef(false);

    const rootElement = document.getElementById('root');

    // UNSAVED MODAL CONTENT
    const confirmUnsavedModalContent = (
        <div>
            {modalMessage !== null ? modalMessage : t("validationMessage.changeNotSave")}
        </div>
    );

    // UNSAVED MODAL FOOTER
    const confirmUnsavedModalButtons = (
        <>
            <Button className="box-green border-0" onClick={() => {
                if (navigateUrl !== "") {
                    setDisplayUnsavedModal(false);
                    if (navigateUrl === HISTORY_BACK_ACTION) {
                        allowHistoryNavigationRef.current = true;
                        window.history.back();
                        return;
                    }
                    navigate(navigateUrl);
                    CustomReload();
                }
            }}>
                {t('button.accept')}
            </Button>
            <Button className="box-red border-0" onClick={() => setDisplayUnsavedModal(false)}>
                {t('button.cancel')}
            </Button>
        </>
    );

    // HANDLE UNSAVED CHANGES
    const HandleUnsavedChanges = (e) => {
        const div = document.querySelector(".page-content");
        const backButtonElement = e.target?.closest?.("button.backButton");
        // CLICK INSIDE
        if (div.contains(e.target)) {
            if (backButtonUrl !== null) {
                if (backButtonElement) {
                    // STOP NAVIGATION FOR INSIDE ROUTE
                    e.stopPropagation();
                    setDisplayUnsavedModal(true);
                    setNavigateUrl(backButtonUrl);
                }
            }
            return;
        }
        else {
            // CLICK OUTSIDE
            if (e.target.parentElement && e.target.parentElement.tagName === "A" && e.target.parentElement.attributes.href && e.target.parentElement.attributes.href.value && e.target.parentElement.attributes.href.value !== "") {
                // STOP NAVIGATION FOR INSIDE ROUTE
                if (e?.target?.parentElement?.parentElement?.className?.trim() === "dropdown") {
                    return;
                }
                e.preventDefault();
                setDisplayUnsavedModal(true);
                setNavigateUrl(e.target.parentElement.attributes.href.value);
            }
            if (e.target.parentElement && e.target.parentElement.parentElement && e.target.parentElement.parentElement.tagName === "A" && e.target.parentElement.parentElement.attributes.href && e.target.parentElement.parentElement.attributes.href.value && e.target.parentElement.parentElement.attributes.href.value !== "") {
                e.preventDefault();
                setDisplayUnsavedModal(true);
                setNavigateUrl(e.target.parentElement.parentElement.attributes.href.value);
            }
            if (e.target.onclick !== null && e.target.tagName === "A" && e.target.attributes.href && e.target.attributes.href.value !== "") {
                if (e.target?.parentElement?.className?.trim() === "dropdown") {
                    return;
                }
                e.preventDefault();
                setDisplayUnsavedModal(true);
                setNavigateUrl(e.target.attributes.href.value);
            }
            // BACK MOBILE
            console.log(e.target);
            if (e.target.id === "mobile-back-button" || (e.target.parentElement && e.target.parentElement.id === "mobile-back-button")) {
                e.preventDefault();
                setDisplayUnsavedModal(true);
                setNavigateUrl(backButtonUrl);
            }
        }
    };

    // HANDLE UNSAVED CHANGES CLOSE
    const HandleUnsavedChangesClose = (e) => {
        e.returnValue = '';
        e.preventDefault();
    };

    // HANDLE BROWSER BACK/FORWARD BUTTON
    const HandlePopState = () => {
        if (allowHistoryNavigationRef.current) {
            allowHistoryNavigationRef.current = false;
            return;
        }

        setDisplayUnsavedModal(true);
        setNavigateUrl(HISTORY_BACK_ACTION);

        // Keep user on current page until they confirm.
        window.history.pushState({ unsavedGuard: true }, '');
    };

    // USE EFFECT TO HANDLE UNSAVED CHANGES
    useEffect(() => {
        if (rootElement) {
            rootElement.addEventListener('click', HandleUnsavedChanges, true);
        }
        window.addEventListener('beforeunload', HandleUnsavedChangesClose);
        window.history.pushState({ unsavedGuard: true }, '');
        window.addEventListener('popstate', HandlePopState);

        return () => {
            if (rootElement) {
                rootElement.removeEventListener('click', HandleUnsavedChanges, true);
            }
            window.removeEventListener('beforeunload', HandleUnsavedChangesClose);
            window.removeEventListener('popstate', HandlePopState);
        }
    }, []);

    return (
        <CustomModal isOpen={displayUnsavedModal} toggle={() => setDisplayUnsavedModal(!displayUnsavedModal)} body={confirmUnsavedModalContent} footer={confirmUnsavedModalButtons} />
    );
}